// extracted by mini-css-extract-plugin
export var cta = "NewsletterSection-module--cta--a2cd7";
export var section = "NewsletterSection-module--section--8eb2a";